"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findQuestionComponent = exports.clonePin = exports.clonePins = exports.sortPins = exports.newPin = void 0;
const models_1 = require("../../models");
const random_id_1 = require("../random-id");
const order_1 = require("../order");
const pin_component_1 = require("../pin-components/pin-component");
const component_reference_processor_1 = require("../component-reference.processor");
const tip_tap_1 = require("../../tip-tap");
const assertions_1 = require("../assertions");
function newPin(pin, id, order) {
    return models_1.TeacherPinSchema.parse({
        ...pin,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        id: id ?? (0, random_id_1.randomId)(),
        order: order ?? 'defaultPinCreationOrder', // will be updated in addPinToList in reducer
        teacherSettings: {
            ...pin.teacherSettings,
            notes: pin.teacherSettings.notes || (0, tip_tap_1.emptyDocument)(),
        },
    });
}
exports.newPin = newPin;
function sortPins(components) {
    return [...components].sort(order_1.orderableCompareFn);
}
exports.sortPins = sortPins;
function clonePins(pins) {
    return pins.map(clonePin);
}
exports.clonePins = clonePins;
function clonePin(pin) {
    const { pinComponents, oldToNewPinComponentIds } = (0, pin_component_1.clonePinComponents)(pin.pinComponents);
    const newPin = {
        ...pin,
        id: (0, random_id_1.randomId)(),
        pinComponents,
    };
    (0, component_reference_processor_1.processPinReferenceFields)(pin, ({ componentId }) => {
        return oldToNewPinComponentIds[componentId];
    }, { ignorePinComponents: true });
    return newPin;
}
exports.clonePin = clonePin;
const findQuestionComponent = (pin, pinComponents) => {
    return pinComponents.find((pinComponent) => (0, assertions_1.isInteractiveQuestionPinTextPinComponent)(pin, pinComponent));
};
exports.findQuestionComponent = findQuestionComponent;
//# sourceMappingURL=pin.js.map